module.exports = __webpack_public_path__ + "static/media/ZlvsWalkme-X.0727e28c.svg";